import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'ip-paged-header',
    templateUrl: './paged-header.component.html',
    styleUrls: ['./paged-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class IpPagedHeaderComponent {
	@Input() title: string;
	@Input() length: number;
	@Input() index: number;
	@Output() next: EventEmitter<void> = new EventEmitter<void>();
	@Output() prev: EventEmitter<void> = new EventEmitter<void>();

	constructor() {}

	get disablePrev(): boolean {
		return this.index === 0;
	}

	get disableNext(): boolean {
		return this.index === this.length - 1;
	}

	advance(direction: 'next' | 'prev') {
		if (direction === 'next') {
			this.next.emit();
		} else if (direction === 'prev') {
			this.prev.emit();
		}
	}
}
